

// Import ----------------------------------------------------------------------

// Nuxt / Vendor
import Vue from "vue";

// Project
import ContentGateway from "~/libs/ContentGateway";
import { PartialContentNode } from "~/libs/Types";

// Export ----------------------------------------------------------------------

export default Vue.extend({

    // Component Attribute Properties ------------------------------------------

    props: {
        item: {
            type: String,
            required: true
        },
        classes: {
            type: String,
            required: false,
            default: ""
        },
        contained: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    // Component Internal Data State -------------------------------------------

    data: () => ({
        partialItem: { name: "" } as PartialContentNode
    }),

    // Nuxt/Vue Hooks ----------------------------------------------------------

    async fetch (): Promise<void> {
        this.partialItem = await ContentGateway.make(this.$nuxt.context).getPartial(this.item);
    },

    // Component Attribute, Properties & Injected ------------------------------

    computed: {
        containedClasses (): Object {
            return {
                "partial-container": this.contained
            };
        }
    }
    // -------------------------------------------------------------------------
});
